import { AlmconnectionCommonApiClient } from "@/natsstubs/almconnection/common/client";
import { keysToSnake } from "@/natsstubs/wire/transform";

import type { NatsRpcBackend } from "../NatsRpcBackend";
import { mapTypedError } from "./mapTypedError";

export function registerAlmConfigAdapters(nats: NatsRpcBackend): void {
  const common = new AlmconnectionCommonApiClient(nats.caller);

  nats.register("alm", "alm-common", {
    get_alm_connections: async () => keysToSnake((await common.getConnections()).connections),

    get_alm_tools: async () => (await common.getAlmTools()).almTools,

    get_session_info: async (args: unknown[]) =>
      keysToSnake(await common.getSession(String(args[0]))),

    create_alm_connection: async (args: unknown[]) => {
      try {
        const { connectionId } = await common.createConnection({ almtool: String(args[0]) });
        return { success: true, id: connectionId };
      } catch (e) {
        return mapTypedError(e, {
          ALMCONNECTION_COMMON__INVALID_CONNECTION_VALUES_ERROR: (error) => ({
            success: false,
            errorCode: 1,
            error,
          }),
          ALMCONNECTION_COMMON__INVALID_ALM_TYPE_ERROR: (error) => ({
            success: false,
            errorCode: 2,
            error,
          }),
        });
      }
    },
  });
}
